import { Card, Popover, Typography } from 'antd'
import { NodeSizeParamsSelector } from 'Components'
import { QuestionCircleOutlined } from '@ant-design/icons'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph style={{ width: 500, lineHeight: '1.6rem' }}>
    You can select an attribute key from the list. This will result in resizing all the nodes with that attribute key respective to that attribute value.
  </Paragraph>
</div>)

info = (
  <Popover
    content={helpText}
    title='Size by attribute'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

NodeSizeParamsPanel = ->

  <Card
    title="Size nodes by attribute value."
    extra={info}
    size="small"
    id="size-nodes-by-attribute-value"
  >
    <NodeSizeParamsSelector updateConfigNode={true}/>
  </Card>

export default NodeSizeParamsPanel

